import React from 'react';
import {connect} from 'react-redux';
import {useFormState} from 'react-final-form';

import {Typography} from '@mui/material';

import {WizardPage} from 'spectra-logic-ui/components';
import {Store} from 'spectra-logic-ui';

import {Pool} from '@/types';

type Props = {
  title: string;
  id: string;
  name: string;
  chosenStorage?: string;
  pools?: Pool[];
}

const confirmAlt = ({title, id, name, pools = [], ...otherProps}: Props) => {
  const formState = useFormState();
  const chosenStorage = formState.values.chosenStorage;

  const pool = pools.find((p) => p.id === chosenStorage) || {} as Pool;
  return (
    <WizardPage title={title} {...otherProps} description={
      <Typography>
      Are you sure you want to permanently delete "{name}" ({id})?
      </Typography>
    }>
      <Typography variant='subtitle1'>
        If any object has "{name}" ({id}) as its only storage, "{pool.name}" ({pool.id}) will be
        added to the object before the storage is deleted.
      </Typography>
    </WizardPage>
  );
};

const mapStateToProps = (state: Store) => {
  const poolsResource = state.resources.storage || {};
  return {pools: poolsResource.data};
};
export default connect(mapStateToProps)(confirmAlt);
